export default "__VITE_ASSET__F1pYh4oQ__"